import { render, staticRenderFns } from "./NeoparentForgotPass.vue?vue&type=template&id=e877c010&scoped=true"
import script from "./NeoparentForgotPass.vue?vue&type=script&lang=js"
export * from "./NeoparentForgotPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e877c010",
  null
  
)

export default component.exports